module.exports = "/packs/images/products/creme-f8a9e87f472c3debefea8af30ba58a3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/creme.jpg
// module id = 733
// module chunks = 0 1 2 4